<m-modal
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  (onHide)="onClose()"
  [styleClass]="'halo-spend-modal'"
  [style]="{ width: '640px' }">
  <ng-container modalHeader>
    <h4 class="h4">Enable {{ exclusionGroupConfig?.keyword }} Effect</h4>
  </ng-container>
  <div class="halo-modal-content">
    <div class="halo-modal-body">
      <div class="halo-modal-hero">
        <img
          src="assets/images/model-input/modelInputUpdateSuccess.svg"
          alt="Halo Effect"
          class="halo-modal-hero-img" />
        <p class="B1">
          This incorporates the indirect influence that one brand has over
          another, like an increase in site traffic or retail sales.
        </p>
      </div>

      <div class="halo-modal-brands">
        <div class="halo-modal-brand-card">
          <span class="halo-modal-brand-label">Influence from</span>
          <span class="halo-modal-brand-name">{{
            exclusionGroupConfig?.mappedBrandName
          }}</span>
        </div>
        <span class="halo-modal-brands-arrow material-symbols-outlined"
          >arrow_forward</span
        >
        <div class="halo-modal-brand-card">
          <span class="halo-modal-brand-label">Impact on</span>
          <span class="halo-modal-brand-name">{{ currentBrandName }}</span>
        </div>
      </div>
    </div>

    <p class="c1">
      If enabled, you can disable this additional influence by clicking the
      toggle again.
    </p>
  </div>
  <ng-container modalFooter>
    <div class="d-flex justify-content-between align-items-center">
      <m-checkbox
        class="halo-modal-dont-show"
        [binary]="true"
        [isChecked]="dontShowAgain"
        (onChange)="onDontShowAgainChange($event)">
        Don't show this again
      </m-checkbox>
      <m-button type="primary" (click)="onEnable()">
        <span class="b1">Enable</span>
      </m-button>
    </div>
  </ng-container>
</m-modal>
